/**
 * Singleton QueryClient shared between prefetch.ts and main.tsx.
 *
 * Both entry points import from this module, guaranteeing a single
 * QueryClient instance regardless of script load order. This eliminates
 * the race where prefetch.ts writes to one client and main.tsx reads
 * from a different one — a failure mode that was silently stranding
 * prefetched data in production.
 */

import { createCRMQueryClient } from './lib/crm';
import { prefetchDebug } from './lib/prefetch/debug';

export const queryClient = createCRMQueryClient();

// Tag the instance so we can verify identity across prefetch.ts and main.tsx
const instanceId = Math.random().toString(36).slice(2, 8);
(queryClient as unknown as Record<string, unknown>).__debugId = instanceId;
prefetchDebug('queryClient singleton created', { instanceId });
